// create Notification for User
const CreateNotification = async (data) => {
  let response = await fetch(`${process.env.REACT_APP_API_URL}/Notifications`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
    },
  }).catch((error) => {
    console.log(error);
  });
  return response.status === 200 ? true : false;
};

export default CreateNotification;
